<template>
  <b-modal :id="id" ref="edit-token-modal" scrollable size="lg" title="Edit token" @show="getPackageList">
    <div class="kt-portlet__body">
      <LoadingSpinner v-if="loading" />
      <div v-else class="kt-widget12">
        <div class="kt-widget12__content">
          <div class="kt-widget12__item">
            <div class="kt-widget12__info">
              <span class="kt-widget12__desc">Token name</span>
              <div class="kt-widget4">
                <input
                  v-model="tokenName"
                  type="text"
                  class="form-control"
                  placeholder="Change your token name"
                  @input="trackCustomEvent({ event: 'input', inPage: routeName, action: 'type', target: 'input_box_content'})"
                >
              </div>
            </div>
          </div>

          <div class="kt-widget12__item">
            <div class="kt-widget12__info">
              <div class="row">
                <div class="col-xl-4 kt-margin-b-10-tablet-and-mobile">
                  <span class="kt-widget12__desc">Token ID</span>
                  <span class="kt-widget12__value" style="font-size: 12px;font-weight: 300;color: #646C9A">{{ tokenDetail.tokenId }}</span>
                </div>
                <div class="col-xl-4 kt-margin-b-10-tablet-and-mobile">
                  <span class="kt-widget12__desc">Last access</span>
                  <span class="kt-widget12__value" style="font-size: 12px;font-weight: 300;color: #646C9A">{{ tokenDetail.lastAccess ? date(tokenDetail.lastAccess) : 'Never' }}</span>
                </div>
                <div class="col-xl-4 kt-margin-b-10-tablet-and-mobile">
                  <span class="kt-widget12__desc">Created at</span>
                  <span class="kt-widget12__value" style="font-size: 12px;font-weight: 300;color: #646C9A">{{ date(tokenDetail.createdAt) }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="kt-widget12__item">
            <div class="kt-widget12">
              <div class="kt-widget12__content">
                <div class="kt-widget12__item">
                  <div class="kt-widget12__info">
                    <span class="kt-widget12__desc">Granted access</span>
                    <div class="kt-widget4 service-selector-wrapper">
                      <service-select
                        v-model="selectingPackage"
                        class="service-selector"
                        :package-list="selectablePackage"
                        @input="trackCustomEvent({ event: 'clicked', inPage: routeName, action: 'input', target: 'modal_selector_content' }); addPackageToGrantedList($event)"
                      />
                    </div>
                  </div>
                </div>
                <div>
                  <div class="kt-widget12__info">
                    <table class="table table-bordered service-table">
                      <thead>
                        <tr>
                          <th rowspan="2" class="grated-service-col">
                            Granted Service
                          </th>
                          <th colspan="3">
                            Quota
                          </th>
                          <th rowspan="2" class="action-col">
                            Action
                          </th>
                        </tr>
                        <tr>
                          <th class="quota-col">
                            Minute
                            <i v-b-tooltip.hover class="flaticon-info" title="A maximum number of request allowed within 1 minute" />
                          </th>
                          <th class="quota-col">
                            Day
                            <i v-b-tooltip.hover class="flaticon-info" title="A maximum number of request allowed within 1 day" />
                          </th>
                          <th class="quota-col">
                            Month
                            <i v-b-tooltip.hover class="flaticon-info" title="A maximum number of request allowed within 1 month" />
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(packages, idx) in grantedPackageList" :key="idx">
                          <td>
                            <div class="service-name kt-widget1__title">
                              <a target="_blank">{{ packages.name }}</a>
                            </div>
                          <!--                            <div class="service-id kt-widget1__sub">-->
                          <!--                              {{ service.description }}-->
                          <!--                            </div>-->
                          </td>
                          <td>
                            <input
                              v-model="packages.quota.minute"
                              class="form-control"
                              type="number"
                              @input="trackCustomEvent({ event: 'input', inPage: routeName, action: 'type', target: 'modal_input_box_content'})"
                            >
                          </td>
                          <td>
                            <input
                              v-model="packages.quota.day"
                              class="form-control"
                              type="number"
                              @input="trackCustomEvent({ event: 'input', inPage: routeName, action: 'type', target: 'modal_input_box_content'})"
                            >
                          </td>
                          <td>
                            <input
                              v-model="packages.quota.month"
                              class="form-control"
                              type="number"
                              @input="trackCustomEvent({ event: 'input', inPage: routeName, action: 'type', target: 'modal_input_box_content'})"
                            >
                          </td>
                          <td>
                            <a
                              title="Delete"
                              class="btn btn-sm btn-clean btn-icon btn-icon-md"
                              @click="trackCustomEvent({ inPage: routeName, action: 'clicked', target: 'modal_button_content'}); deleteGrantedPackage(idx)"
                            >
                              <i class="la la-trash" />
                            </a>
                          </td>
                        </tr>
                        <tr v-if="grantedPackageList.length === 0">
                          <td colspan="10">
                            No data
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <template v-slot:modal-footer>
      <div>
        <button
          class="btn btn-brand btn-icon-sm"
          :class="{ 'kt-spinner kt-spinner--sm kt-spinner--light' : updatingToken }"
          @click="trackCustomEvent({ inPage: routeName, action: 'clicked', target: 'modal_update_token_content'}); updateToken()"
        >
          Update Token
        </button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import _ from 'lodash'
import moment from 'moment'
import { BModal, VBModal, VBTooltip } from 'bootstrap-vue'
import ServiceSelector from './ServiceSelector'
import LoadingSpinner from '../components/LoadingSpinner'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'EditTokenModal',
  components: {
    LoadingSpinner,
    'b-modal': BModal,
    'service-select': ServiceSelector
  },
  directives: {
    'b-modal': VBModal,
    'b-tooltip': VBTooltip
  },
  props: { id: String, projectId: String, userId: String },
  data () {
    return {
      loading: false,
      updatingToken: false,
      tokenDetail: {},
      selectingPackage: null,
      packageList: [],
      grantedPackageList: [],
      toDeletePackageList: [],
      tokenName: '',
      token: null
    }
  },
  computed: {
    ...mapGetters({
      getPackageListState: 'project/getPackageListState'
    }),
    routeName () {
      return this.$route.name
    },
    selectablePackage () {
      const grantedPackageIDSet = new Set(
        this.grantedPackageList.map(packages => packages.packageName)
      )
      return this.getPackageListState.filter(
        packages => !grantedPackageIDSet.has(packages.packageName)
      ).sort((a, b) => {
        if (a.name.toUpperCase() > b.name.toUpperCase()) {
          return 1
        } else if (a.name.toUpperCase() < b.name.toUpperCase()) {
          return -1
        }
      })
    }
  },
  methods: {
    ...mapActions({
      getTokenDetailRequest: 'project/getTokenDetail',
      getSingleTokenDeepDetailRequest: 'project/getSingleTokenDeepDetail',
      getPackageList: 'project/getPackageList',
      addPackageToToken: 'project/addPackageToToken',
      editPackageInToken: 'project/editPackageInToken',
      deletePackageFromToken: 'project/deletePackageFromToken',
      trackCustomEvent: 'user/trackCustomEvent'
    }),
    async show (token) {
      this.token = token
      this.loadTokenDetail(token)
      this.$refs['edit-token-modal'].show()
    },
    async loadTokenDetail (token) {
      this.resetTokenDetail()
      if (token) {
        this.loading = true
        await this.getTokenDetail(token)
        this.loading = false
      }
    },
    resetTokenDetail () {
      this.updatingToken = false
      this.tokenDetail = {}
      this.selectingPackage = null
      this.packageList = []
      this.grantedPackageList = []
    },
    date (value) {
      if (value) {
        return moment(value).format('DD/MM/YYYY HH:mm')
      } else {
        return 'Never'
      }
    },
    addPackageToGrantedList (selectingPackage) {
      if (selectingPackage) {
        const grantedPackageData = {
          ...selectingPackage,
          quota: {
            minute: 10,
            day: 2000,
            month: 20000
          }
        }
        this.grantedPackageList = [grantedPackageData].concat(this.grantedPackageList)
        this.selectingPackage = null
      }
    },
    deleteGrantedPackage (index) {
      this.toDeletePackageList.push(this.grantedPackageList[index])
      this.grantedPackageList.splice(index, 1)
    },
    async getTokenDetail (token) {
      const tokenDetail = await this.getSingleTokenDeepDetailRequest(token)
      this.tokenDetail = tokenDetail.data
      this.tokenName = this.tokenDetail.name
      //  TODO Reconsider this block agin or change API to return both all of package data
      for (const packages of this.tokenDetail.packages) {
        for (const packagesList of this.getPackageListState) {
          if (packages.name === packagesList.name) {
            this.grantedPackageList.push({
              description: packagesList.description,
              name: packagesList.name,
              packageName: packagesList.packageName,
              quota: {
                minute: parseInt(packages.quota.minute),
                day: parseInt(packages.quota.day),
                month: parseInt(packages.quota.month)
              },
              services: packagesList.services
            })
          }
        }
      }
    },
    async updateToken () {
      this.updatingToken = true

      // Add new package to token
      for (const packages of this.grantedPackageList) {
        for (let i = 0; i < this.tokenDetail.packages.length; i++) {
          if (this.tokenDetail.packages[i].name === packages.name) {
            break
          } else if (i === this.tokenDetail.packages.length - 1) {
            await this.addPackageToToken({
              token: this.token,
              packageName: packages.packageName,
              quota: {
                minute: parseInt(packages.quota.minute),
                day: parseInt(packages.quota.day),
                month: parseInt(packages.quota.month)
              }
            })
          }
        }
      }

      // Update package in token
      for (const packages of this.grantedPackageList) {
        await this.editPackageInToken({
          token: this.token,
          name: this.tokenName,
          packageName: packages.packageName,
          quota: {
            minute: parseInt(packages.quota.minute),
            day: parseInt(packages.quota.day),
            month: parseInt(packages.quota.month)
          }
        })
      }

      // Delete package from token
      for (const delPackage of this.toDeletePackageList) {
        for (const defaultPackage of this.tokenDetail.packages) {
          if (defaultPackage.name === delPackage.name) {
            await this.deletePackageFromToken({
              token: this.token,
              packageName: delPackage.packageName
            })
            break
          }
        }
      }

      const updateToken = await this.getTokenDetailRequest({
        projectId: this.projectId,
        token: this.token
      })
      this.$emit('tokenUpdated', updateToken)
      this.$refs['edit-token-modal'].hide()
      this.updatingToken = false
    }
  }
}
</script>

<style scoped>
  .kt-subheader--enabled.kt-subheader--transparent:not(.kt-subheader--fixed)
  .kt-content {
    padding-top: 0;
  }

  table button {
    margin: 0 0.3em;
  }

  .service-table {
    text-align: center;
  }

  .service-table td,
  .service-table th {
    vertical-align: middle;
  }

  .service-selector-wrapper {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
  }

  .service-selector {
    flex-grow: 1;
    margin-left: 5px;
    margin-right: 5px;
  }

  .grated-service-col {
    width: 340px;
  }
  .quota-col {
    width: 121px;
  }
  .action-col {
    width: 40px;
  }
</style>
